import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function FormSection({ id, className, title, children }) {
  return (
    <div
      id={id}
      className={classNames('form-section', {
        [className]: className
      })}
    >
      <span className="section-title">{title}</span>
      {children}
    </div>
  );
}

FormSection.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
};

export default FormSection;
